import Vue from 'vue'

import { randomString, isObjectEmpty } from '../../util'

/**
 * @param {Object}  obj - The widget obj
 * @param {string}  obj.name - The name of the component 
 * @param {Object}  obj.component - The vue component that will be renderized
 * @param {Element} obj.container - The container where the component will be renderized
 * @param {Object}  obj.config - The configuration data of the component
 * @param {Array}   obj.ignored - The vue ignored elements array
 */
export function renderWidget({ container, name, component, config, ignored }) {
  name = name.toLowerCase()
  config = !isObjectEmpty(config) ? config : {}
  ignored = ignored || []

  if (!component)
    throw new Error('Invalid component object')

  Vue.component(name, component)
  Vue.config.ignoredElements = ignored

  const wrapper = document.createElement('div')
  wrapper.id = randomString(15)

  container.innerHTML = ''
  container.appendChild(wrapper)

  new Vue({
    el: `#${wrapper.id}`,
    template: `<${name} :config="config"></${name}>`,
    data: function() {
      return { config }
    }
  })
}
